var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _rect, _g, _g2, _rect2, _rect3, _rect4, _g3, _circle, _rect5, _g4, _ellipse, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 220,
    viewBox: "0 0 604 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 209,
    x2: 504.5,
    y2: 209,
    stroke: "url(#paint0_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 180,
    x2: 558.5,
    y2: 180,
    stroke: "url(#paint1_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 151,
    x2: 585.5,
    y2: 151,
    stroke: "url(#paint2_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 122,
    x2: 602.5,
    y2: 122,
    stroke: "url(#paint3_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 94,
    x2: 602.5,
    y2: 94,
    stroke: "url(#paint4_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 65,
    x2: 585.5,
    y2: 65,
    stroke: "url(#paint5_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 36,
    x2: 558.5,
    y2: 36,
    stroke: "url(#paint6_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 7,
    x2: 504.5,
    y2: 7,
    stroke: "url(#paint7_linear_4536_110224)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 40.5,
    width: 138,
    height: 137,
    rx: 68.5,
    fill: "#FCE9DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4536_110224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 88.8945,
    width: 69.702,
    height: 69.702,
    rx: 16,
    transform: "rotate(-20.4862 257 88.8945)",
    fill: "url(#paint8_linear_4536_110224)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 271.717,
    y: 85.4922,
    width: 68,
    height: 68
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_4536_110224_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_4536_110224)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.717,
    y: 89.4922,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    fillOpacity: 0.31
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 99,
    width: 39,
    height: 15,
    rx: 5,
    stroke: "white",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 118.5,
    width: 40,
    height: 11,
    rx: 3.5,
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 132.5,
    width: 32,
    height: 11,
    rx: 3.5,
    stroke: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4536_110224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 52,
    width: 52,
    height: 46,
    rx: 9,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 378.5,
    cy: 63.5,
    r: 5.5,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 71,
    width: 23,
    height: 17,
    rx: 8.5,
    fill: "#D9D9D9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4536_110224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 151,
    width: 30,
    height: 27,
    rx: 9,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.289,
    cy: 157.75,
    rx: 3.17308,
    ry: 3.22826,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 250.654,
    y: 162.152,
    width: 13.2692,
    height: 9.97826,
    rx: 4.98913,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4536_110224",
    x: 245.583,
    y: 57.084,
    width: 112.521,
    height: 112.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4536_110224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4536_110224",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4536_110224"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4536_110224",
    result: "effect3_innerShadow_4536_110224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_4536_110224",
    x: 271.717,
    y: 85.4922,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4536_110224"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4536_110224",
    result: "effect2_innerShadow_4536_110224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4536_110224_clip_path",
    transform: "translate(-271.717 -85.4922)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.717,
    y: 89.4922,
    width: 60,
    height: 60,
    rx: 16
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4536_110224",
    x: 344,
    y: 47,
    width: 68,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4536_110224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4536_110224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4536_110224",
    x: 234,
    y: 146,
    width: 46,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4536_110224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4536_110224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4536_110224",
    x1: 98,
    y1: 211,
    x2: 506,
    y2: 211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4536_110224",
    x1: 44,
    y1: 182,
    x2: 560,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4536_110224",
    x1: 17,
    y1: 153,
    x2: 587,
    y2: 153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4536_110224",
    x1: 0,
    y1: 124,
    x2: 604,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4536_110224",
    x1: 0,
    y1: 96,
    x2: 604,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4536_110224",
    x1: 17,
    y1: 67,
    x2: 587,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4536_110224",
    x1: 44,
    y1: 38,
    x2: 560,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4536_110224",
    x1: 98,
    y1: 9,
    x2: 506,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4536_110224",
    x1: 291.851,
    y1: 88.8945,
    x2: 291.851,
    y2: 158.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-color-text)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9631F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.a8a548c5e4ca419a319d7ec9852bfdef.svg";
export { ForwardRef as ReactComponent };